/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2025 Rochester Software Associates (service@rocsoft.com)
 */


import periodicPoller from '~/api/periodicPoller';
import { useCurrentUser, useIsUserLoggedIn } from '~/components/user/UserContext';
import { poll as pollReviews } from '~api/ordering/reviews';


const { usePeriodicPoller, executePollOnce } = periodicPoller({ defaultIntervalMS: 30_000, poll: pollReviews, initialValue: 0 });

/**
 * Initiate a polling function that will poll for the current reviews every 30 seconds
 */
export const useCurrentReviews = () => {
    const currentUser = useCurrentUser();
    const isUserLoggedIn = useIsUserLoggedIn();

    const reviewPollingInMS = currentUser?.speedAndReliability?.reviewPollingInMS;

    // Only poll if the user is logged in
    const reviewsFromPoll = usePeriodicPoller(isUserLoggedIn, reviewPollingInMS);
    // We return the state containing the array of the reviews that were found in the poll (reviewsFromPoll), this will be returned to the ReviewItem
    // component, and since it's a state, if a future poll changes that state (in 30 seconds), the ReviewItem will update on its own

    // The second thing we return is a function that will initiate a poll manually. This is used for cases where the review count
    // would expectedly change like submitting an order or sending back a review. We don't want to wait 30 seconds for the red counter
    // to decrease so we initiate a poll, which will update the state above, which will update the ReviewItem
    return { reviewsFromPoll, pollReviews: executePollOnce };
};